import React from 'react';

interface Props {
    name: string;
    value: boolean;
    label?: string | React.ReactNode;
    disabled?: boolean;

    isLabelLeft?: boolean;

    isSmall?: boolean;

    onChange: (newValue: boolean) => void;
}

const Toggle: React.FC<Props> = ({
    name,
    onChange,
    label,
    value = false,
    disabled = false,
    isLabelLeft = false,
    isSmall = false,
}: Props) => {
    return (
        <div className="flex  w-full">
            {!!label && isLabelLeft && <div className="ml-3 text-gray-700 font-semibold mr-2 pt-1">{label}</div>}
            {isSmall ? (
                <button
                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 ${
                        value ? 'focus:ring-blue-500 focus:ring-offset-2 bg-blue-600' : 'bg-gray-200'
                    }`}
                    onClick={() => onChange(!value)}
                >
                    <span
                        className={` pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                            value ? 'translate-x-5' : 'translate-x-0'
                        }`}
                    ></span>
                </button>
            ) : (
                <label className={`flex items-center `}>
                    <div className={`relative ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                        <input
                            type="checkbox"
                            id={'toggle' + name}
                            className="sr-only "
                            name={name}
                            onChange={() => onChange(!value)}
                            checked={value}
                            disabled={disabled}
                        />
                        <div className={`block ${value ? 'bg-blue-600' : 'bg-gray-600'} w-14 h-8 rounded-full`}></div>
                        <div className="dot absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition"></div>
                    </div>
                    {!!label && !isLabelLeft && <div className="ml-3 text-gray-700 font-semibold">{label}</div>}
                </label>
            )}
        </div>
    );
};

export default Toggle;
